import React, { Component } from 'react'
import './style.scss'
class ShopingCard extends Component {

  render() {
    const { url, icon, title, value, total, onClick } = this.props
    return (
      <div className="shoping-card" onClick={() => { onClick && onClick() }}>
        <div className="photo" style={{ backgroundImage: `url(${url})` }}>
        </div>
        <div className="title">
          
          <span>{icon} {title}</span>
        </div>
        <div className="value">
          {`R$${Number(value).toFixed(2)} / R$${Number(total).toFixed(2)}`}
        </div>
      </div>
    )
  }
}

export default ShopingCard